export default __webpack_public_path__ + "static/media/SLIDE_ESCALERAS_8.761f3283.jpg";